import baseService from './baseService';
import config from '../../config';

export default{
    getFavorites(params)
    {
        return baseService.get(config.API_LOCATION + 'user/favorites',params)
    },
    updateProfile(params){
        return baseService.post(config.API_LOCATION + 'user/updateProfile',params)
    },
    changePassword(params){
        return baseService.post(config.API_LOCATION + 'user/changePassword',params)
    },
    getFavoriteIds()
    {
        return baseService.get(config.API_LOCATION + 'user/favorite/ids',{})
    }

}

